import axios from "axios";
import app from "../_app";
import product from "../product";
import wishlist from "./_wishlist";

const productblocks = [...document.querySelectorAll('.js-productblock')];

const fetchData = async url => {
    let response = await axios.get(`${url}.js`);

    if(response.status === 200) {
        return response.data;
    }

    return false;
};

const data = {};

export const productblockInit = async (productblock, dynamicUrl = null) => {
    const variants = [...productblock.querySelectorAll('.js-productblock-color')];

    if(variants.length > 0 || dynamicUrl !== null) {
        const image = productblock.querySelector('.js-productblock-image');
        const image2 = productblock.querySelector('.js-productblock-image2');
        const title = productblock.querySelector('.js-productblock-title');
        const price = productblock.querySelector('.js-productblock-price');
        const priceOld = productblock.querySelector('.js-productblock-price-old');
        const wishlistTrigger = productblock.querySelector('.js-wishlist-trigger');

        let currentProduct = productblock.dataset.product;
        let currentVariant = +variants.find(variant => variant.hasAttribute('data-original'))?.dataset?.variant;

        const fetchProduct = async (product, variant = null) => {
            if(+variant?.dataset?.variant !== currentVariant) {
                if(!data[product]) {
                    data[product] = await fetchData(product);
                }

                switchColor(product, variant);
            }
        }

        const switchImage = (picture, url, alt) => {
            const sourceMobile = picture.children[0];
            const sourceDesktop = picture.children[1];
            const img = picture.children[2];

            sourceMobile.setAttribute('srcset', `${app.image(url, null, 186)} 1x, ${app.image(url, null, 372)} 2x`)
            sourceDesktop.setAttribute('srcset', `${app.image(url, null, 330)} 1x, ${app.image(url, null, 660)} 2x`);
            img.setAttribute('src', app.image(url, null, 186));
            img.setAttribute('alt', alt);
        }

        const switchColor = (product, variant = null) => {
            const productObject = data[product];
            let variantObject;

            if(variant !== null) {
                variantObject = productObject.variants.find(v => v.id === +variant.dataset.variant)
            } else {
                variantObject = productObject.variants[0];
            }

            const variantUrl = `${productObject.url}?variant=${variantObject.id}`;

            productblock.setAttribute('href', variantUrl);
            title.innerText = productObject.title;
            price.innerText = app.currency(variantObject.price);
            wishlistTrigger.dataset.url = productObject.url;

            if(wishlist.containsProduct(productObject.url)) {
                wishlistTrigger.setAttribute('data-in', '');
            } else {
                wishlistTrigger.removeAttribute('data-in');
            }

            switchImage(image, variantObject.featured_image.src, variantObject.featured_image.alt || '');

            if(variant !== null) {
                if(variant.hasAttribute('data-second-image')) {
                    switchImage(image2, variant.dataset.secondImage, '');
                    image.setAttribute('data-second-image', '');
                    image2.removeAttribute('data-hidden');
                } else {
                    image.removeAttribute('data-second-image');
                    image2.setAttribute('data-hidden', '');
                }
            }

            if(variantObject.compare_at_price && variantObject.compare_at_price > 0 && variantObject.compare_at_price > variantObject.price) {
                priceOld.innerText = app.currency(variantObject.compare_at_price);
                priceOld.removeAttribute('data-hidden');
            } else {
                priceOld.setAttribute('data-hidden', '');
            }

            variants.map(v => {
                if(+v.dataset.variant === +variant.dataset.variant) {
                    v.setAttribute('data-current', '');
                } else {
                    v.removeAttribute('data-current');
                }
            });

            currentVariant = +variant?.dataset?.variant;
        }

        variants.map(variant => {
            variant.addEventListener('click', async e => {
                e.preventDefault();

                await fetchProduct(currentProduct, variant);
            });
        });

        if(dynamicUrl !== null) {
            return await fetchProduct(dynamicUrl);
        } else {
            productblock.addEventListener('mouseleave', () => variants.find(variant => variant.hasAttribute('data-original')).dispatchEvent(new Event('click')));
        }
    }
};

productblocks.map(productblock => productblockInit(productblock));
